import { render, staticRenderFns } from "./tableIndex.vue?vue&type=template&id=21a5fb0a&scoped=true"
import script from "./tableIndex.vue?vue&type=script&lang=js"
export * from "./tableIndex.vue?vue&type=script&lang=js"
import style0 from "./tableIndex.vue?vue&type=style&index=0&id=21a5fb0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a5fb0a",
  null
  
)

export default component.exports